import React from "react";
import classNames from "classnames";
import ClipLoader from 'react-spinners/ClipLoader';

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import API from "@beardeddevops/react.api";
import {TextField} from "@material-ui/core";
import {toast} from "react-toastify";
/**
 *  @property {Inventories_Object} state
 *  @property {object} model
 *  @property {Inventories_Properties} model.properties
 *  @property {Inventories_Is} model.is
 *  @property {Inventories_Has} model.has
 */

export default class InventoryObject extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Inventories._name);
		this.state.event_description = "Manual Adjustment";
		this.state.quantity = 0;
	}

	loadSelfAfter(data) {
		this.setState({quantity: 0, quantityOnHand: data.quantity ?? 0});
	}

	afterSubmit = (data) => {
		this.setState({quantity: 0, quantityOnHand: data.quantity ?? 0});
	}

	handleSkuChange = (property, value) => {
		this.handleSelectPropertyUpdate(property, value);
		if (value) {
			this.setState({pkey: value}, () => {
				this.loadSelf();
			});
		} else {
			this.setState({quantityOnHand: 0, quantity: 0});
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (prevProps.sku !== this.state.sku)
		{
			this.state.pkey = this.state.sku;
		}
	}

	handleSubmit = async (event) => {
		if (typeof event !== 'undefined') event.preventDefault();
		if (parseFloat(this.state.quantity) === 0 || this.state.quantity === '' || this.state.quantity == null) {
			API.ToastId = toast.error("Quantity must not be 0.", {position: toast.POSITION.TOP_CENTER});
			return;
		}
		if (!this.props.id)
		{
			this.read = 'POST';
			super.handleSubmit(event, false);
		}
		else
		{
			super.handleSubmit(event, false);
		}
	}
	form = () => {
		let {properties} = this.model;
		/**
		 *  @type {Inventories_Object} object
		 */
		let object = this.state;
		let {loading} = this.state;
		object.account = this.props.account
		object.location = this.props.locations
		return (
			<div>

				<fieldset>
					<h4 className="section-title">
						Inventory Restocking
					</h4>
				<div className="form-group">
					<Framework.Elements.Select
						text ={"name(sku"}
						shouldLoad={true}
						update={this.props.id ? this.handleSelectPropertyUpdate : this.handleSkuChange}
						property={properties.sku}
						value={object.sku}
						error={object.sku_error}
						object={object.skus}
						model={Types.Skus._name}
						nullable={false}
						limit={null}
						sort={'name'}
						disabled={!!this.props.id}
					/>
				</div>

			<div className={"form-group"}>
				<TextField
					label={"Quantity On Hand"}
					value={this.state.quantityOnHand ?? 0}
					disabled
					fullWidth
					variant={"outlined"}
					margin={"dense"}
				/>
			</div>
			<div className={"form-group"}>
				<Framework.Elements.NumberField
					name={"number"}
					label={"Quantity To Adjust"}
					property={ properties.quantity}
					value={object.quantity}
					error={object.quantity_error}
					update={this.handleTextFieldPropertyUpdate}
					allowNegative = {true}

				/>
			</div>
				<p style={{
					color: "gray",
					padding: "0 4px",
					marginBottom: "19px",
					fontSize: "11px",
					lineHeight: '12px'
				}}>
					Use Negative Numbers to Remove Stock.
				</p>
			<div className={"form-group"}>
				<Framework.Elements.TextField
					label={"Ledger Note"}
					property={properties.event_description}
					value={object.event_description}
					error={object.event_description_error}
					update={this.handleTextFieldPropertyUpdate}
				/>
			</div>
				</fieldset>


				<div className={classNames("loader", {'active': loading})}>
					<ClipLoader color={"#4A4A4A"} loading={loading}/>
				</div>
			</div>
		)
	}
}
